/**
 * Created by Mattias on 2014-10-01.
 */

define('payment/externalPopupWindow',['jquery'], function($) {
    'use strict';

    function getExternalWindow(windowName, flow, width, height) {
        if (width === undefined) {
            width = 1000;
        }
        if (height === undefined) {
            height = 750;
        }
        var left = (screen.availWidth / 2) - (width / 2);
        var top =(screen.availHeight / 2) - (height / 2);

        var windowFeatures = {
            width:  width,
            height: height,
            left: left,
            top:  top,
            scrollbars: 'yes',
            menubar: 'yes'
        };

        var windowFeaturesStr = '';
        $.each( windowFeatures, function( key, value ) {
            if(windowFeaturesStr.length > 0){
                windowFeaturesStr += ',';
            }
            windowFeaturesStr += key;
            windowFeaturesStr += '=';
            windowFeaturesStr += value;
        });

        // return window.open('', windowName, windowFeaturesStr);
        return window.open('/pp?flow=' + flow, windowName, windowFeaturesStr);
    }

    function getMethod(externalWindowParameters) {
        var defaultMethod = {
            method: 'post'
        };
        return $.extend(defaultMethod, externalWindowParameters);
    }

    function redirectToProvider(externalDocument, externalWindowUrl, externalWindowParameters){
        var div = externalDocument.createElement('div');
        div.setAttribute('style', 'display: none;');
        div.style.display = 'none';

        var form = externalDocument.createElement('form');
        form.setAttribute('action', externalWindowUrl);
        form.setAttribute('method', getMethod(externalWindowParameters).method);
        form.setAttribute('target', '_self');

        $.each(externalWindowParameters, function( key, value ) {
            var inputElement = externalDocument.createElement('input');
            inputElement.setAttribute('name', key);
            inputElement.setAttribute('value', value);
            form.appendChild(inputElement);
        });

        div.appendChild(form);
        externalDocument.body.appendChild(div);

        form.submit();
    }

    function handleCloseAndPlayerRedirect(externalWindow, paymentBox, boxLoading, asynchronousResult, accHistRef, paymentFetchResultFlow){
        // Detecting externalWindow.onClose does not seem to be reliable cross browser
        var loop = setInterval(function() {
            if(externalWindow.closed) {
                // Player have closed window himself
                clearInterval(loop);
                paymentBox.$box.find('.deposit-button').prop('disabled', false);
				paymentBox.$box.find('.withdraw-button').prop('disabled', false);
                boxLoading.removeLoading(paymentBox.$box);
                // We will not poll final deposit result, because we don't believe that the player finalized the deposit
            } else{
                // Provider popup window is still open, check if popup window have been redirect to us again
                try{
                    // Player was redirected to us again, we probably will get a final result soon or already have one
                    if(detectRedirected(externalWindow)){
                        externalWindow.close();
                        clearInterval(loop);
                        onExternalPopupWindowOnClose(asynchronousResult, accHistRef, paymentFetchResultFlow);
                    }

                } catch(exception){
                    // Still on provider page
                    console.log('Still on provider page');
                }
            }
        }, 1000);
    }

    function detectRedirected(externalWindow){
        var popupWindowRedirectDiv = externalWindow.$('#PLAYER_REDIRECT_POPUP_WINDOW');
        return popupWindowRedirectDiv.length > 0;
    }

    function onExternalPopupWindowOnClose(asynchronousResult, accHistRef, paymentFetchResultFlow) {
        if(asynchronousResult === true){
            window.top.getPaymentResult.getAsynchronousPaymentResultAndShowFinalResult(accHistRef, paymentFetchResultFlow);
        } else{
            window.top.getPaymentResult.getSynchronousDepositResultAndShowFinalResult(accHistRef, paymentFetchResultFlow);
        }
    }

    var externalPopupWindow = {};
    externalPopupWindow.getExternalWindow = getExternalWindow;
    externalPopupWindow.redirectToProvider = redirectToProvider;
    externalPopupWindow.handleCloseAndPlayerRedirect = handleCloseAndPlayerRedirect;
    return externalPopupWindow;

});

